{
  "Product": {
    "fe9f": "Google Chromecast",
    "fea0": "Google Chromecast",
    "feaa": "Google Eddystone"
  },
  "Organization": {
    "fcf0": "Security Enhancement Systems, LLC",
    "fcf1": "Google LLC",
    "fcf2": "Bitwards Oy",
    "fcf3": "Armatura LLC",
    "fcf4": "Allegion",
    "fcf5": "Trident Communication Technology, LLC",
    "fcf6": "The Linux Foundation",
    "fcf7": "Honor Device Co., Ltd.",
    "fcf8": "Honor Device Co., Ltd.",
    "fcf9": "Leupold & Stevens, Inc.",
    "fcfa": "Leupold & Stevens, Inc.",
    "fcfb": "Shenzhen Benwei Media Co., Ltd.",
    "fcfc": "Barrot Technology Limited",
    "fcfd": "Barrot Technology Limited",
    "fcfe": "Sennheiser Consumer Audio GmbH",
    "fcff": "701x",
    "fd00": "FUTEK Advanced Sensor Technology, Inc.",
    "fd01": "Sanvita Medical Corporation",
    "fd02": "LEGO System A/S",
    "fd03": "Quuppa Oy",
    "fd04": "Shure Inc.",
    "fd05": "Qualcomm Technologies, Inc.",
    "fd06": "RACE-AI LLC",
    "fd07": "Swedlock AB",
    "fd08": "Bull Group Incorporated Company",
    "fd09": "Cousins and Sears LLC",
    "fd0a": "Luminostics, Inc.",
    "fd0b": "Luminostics, Inc.",
    "fd0c": "OSM HK Limited",
    "fd0d": "Blecon Ltd",
    "fd0e": "HerdDogg, Inc",
    "fd0f": "AEON MOTOR CO.,LTD.",
    "fd10": "AEON MOTOR CO.,LTD.",
    "fd11": "AEON MOTOR CO.,LTD.",
    "fd12": "AEON MOTOR CO.,LTD.",
    "fd13": "BRG Sports, Inc.",
    "fd14": "BRG Sports, Inc.",
    "fd15": "Panasonic Corporation",
    "fd16": "Sensitech, Inc.",
    "fd17": "LEGIC Identsystems AG",
    "fd18": "LEGIC Identsystems AG",
    "fd19": "Smith & Nephew Medical Limited",
    "fd1a": "CSIRO",
    "fd1b": "Helios Sports, Inc.",
    "fd1c": "Brady Worldwide Inc.",
    "fd1d": "Samsung Electronics Co., Ltd",
    "fd1e": "Plume Design Inc.",
    "fd1f": "3M",
    "fd20": "GN Hearing A/S",
    "fd21": "Huawei Technologies Co., Ltd.",
    "fd22": "Huawei Technologies Co., Ltd.",
    "fd23": "DOM Sicherheitstechnik GmbH & Co. KG",
    "fd24": "GD Midea Air-Conditioning Equipment Co., Ltd.",
    "fd25": "GD Midea Air-Conditioning Equipment Co., Ltd.",
    "fd26": "Novo Nordisk A/S",
    "fd27": "i2Systems",
    "fd28": "Julius Blum GmbH",
    "fd29": "Asahi Kasei Corporation",
    "fd2a": "Sony Corporation",
    "fd2b": "The Access Technologies",
    "fd2c": "The Access Technologies",
    "fd2d": "Xiaomi Inc.",
    "fd2e": "Bitstrata Systems Inc.",
    "fd2f": "Bitstrata Systems Inc.",
    "fd30": "Sesam Solutions BV",
    "fd31": "LG Electronics Inc.",
    "fd32": "Gemalto Holding BV",
    "fd33": "DashLogic, Inc.",
    "fd34": "Aerosens LLC.",
    "fd35": "Transsion Holdings Limited",
    "fd36": "Google LLC",
    "fd37": "TireCheck GmbH",
    "fd38": "Danfoss A/S",
    "fd39": "PREDIKTAS",
    "fd3a": "Verkada Inc.",
    "fd3b": "Verkada Inc.",
    "fd3c": "Redline Communications Inc.",
    "fd3d": "Woan Technology (Shenzhen) Co., Ltd.",
    "fd3e": "Pure Watercraft, inc.",
    "fd3f": "Cognosos, Inc",
    "fd40": "Beflex Inc.",
    "fd41": "Amazon Lab126",
    "fd42": "Globe (Jiangsu) Co.,Ltd",
    "fd43": "Apple Inc.",
    "fd44": "Apple Inc.",
    "fd45": "GB Solution co.,Ltd",
    "fd46": "Lemco IKE",
    "fd47": "Liberty Global Inc.",
    "fd48": "Geberit International AG",
    "fd49": "Panasonic Corporation",
    "fd4a": "Sigma Elektro GmbH",
    "fd4b": "Samsung Electronics Co., Ltd.",
    "fd4c": "Adolf Wuerth GmbH & Co KG",
    "fd4d": "70mai Co.,Ltd.",
    "fd4e": "70mai Co.,Ltd.",
    "fd4f": "Forkbeard Technologies AS",
    "fd50": "Hangzhou Tuya Information Technology Co., Ltd",
    "fd51": "UTC Fire and Security",
    "fd52": "UTC Fire and Security",
    "fd53": "PCI Private Limited",
    "fd54": "Qingdao Haier Technology Co., Ltd.",
    "fd55": "Braveheart Wireless, Inc.",
    "fd56": "Resmed Ltd",
    "fd57": "Volvo Car Corporation",
    "fd58": "Volvo Car Corporation",
    "fd59": "Samsung Electronics Co., Ltd.",
    "fd5a": "Samsung Electronics Co., Ltd.",
    "fd5b": "V2SOFT INC.",
    "fd5c": "React Mobile",
    "fd5d": "maxon motor ltd.",
    "fd5e": "Tapkey GmbH",
    "fd5f": "Oculus VR, LLC",
    "fd60": "Sercomm Corporation",
    "fd61": "Arendi AG",
    "fd62": "Fitbit, Inc.",
    "fd63": "Fitbit, Inc.",
    "fd64": "INRIA",
    "fd65": "Razer Inc.",
    "fd66": "Zebra Technologies Corporation",
    "fd67": "Montblanc Simplo GmbH",
    "fd68": "Ubique Innovation AG",
    "fd69": "Samsung Electronics Co., Ltd",
    "fd6a": "Emerson",
    "fd6b": "rapitag GmbH",
    "fd6c": "Samsung Electronics Co., Ltd.",
    "fd6d": "Sigma Elektro GmbH",
    "fd6e": "Polidea sp. z o.o.",
    "fd70": "GuangDong Oppo Mobile Telecommunications Corp., Ltd",
    "fd71": "GN Hearing A/S",
    "fd72": "Logitech International SA",
    "fd73": "BRControls Products BV",
    "fd74": "BRControls Products BV",
    "fd75": "Insulet Corporation",
    "fd76": "Insulet Corporation",
    "fd77": "Withings",
    "fd78": "Withings",
    "fd79": "Withings",
    "fd7a": "Withings",
    "fd7b": "WYZE LABS, INC.",
    "fd7c": "Toshiba Information Systems(Japan) Corporation",
    "fd7d": "Center for Advanced Research Wernher Von Braun",
    "fd7e": "Samsung Electronics Co., Ltd.",
    "fd7f": "Husqvarna AB",
    "fd80": "Phindex Technologies, Inc",
    "fd81": "CANDY HOUSE, Inc.",
    "fd82": "Sony Corporation",
    "fd83": "iNFORM Technology GmbH",
    "fd84": "Tile, Inc.",
    "fd85": "Husqvarna AB",
    "fd86": "Abbott",
    "fd87": "Google LLC",
    "fd88": "Urbanminded LTD",
    "fd89": "Urbanminded LTD",
    "fd8a": "Signify Netherlands B.V.",
    "fd8b": "Jigowatts Inc.",
    "fd8c": "Google LLC",
    "fd8d": "quip NYC Inc.",
    "fd8e": "Motorola Solutions",
    "fd8f": "Matrix ComSec Pvt. Ltd.",
    "fd90": "Guangzhou SuperSound Information Technology Co.,Ltd",
    "fd91": "Groove X, Inc.",
    "fd92": "Qualcomm Technologies International, Ltd. (QTIL)",
    "fd93": "Bayerische Motoren Werke AG",
    "fd94": "Hewlett Packard Enterprise",
    "fd95": "Rigado",
    "fd96": "Google LLC",
    "fd97": "June Life, Inc.",
    "fd98": "Disney Worldwide Services, Inc.",
    "fd99": "ABB Oy",
    "fd9a": "Huawei Technologies Co., Ltd.",
    "fd9b": "Huawei Technologies Co., Ltd.",
    "fd9c": "Huawei Technologies Co., Ltd.",
    "fd9d": "Gastec Corporation",
    "fd9e": "The Coca-Cola Company",
    "fd9f": "VitalTech Affiliates LLC",
    "fda0": "Secugen Corporation",
    "fda1": "Groove X, Inc",
    "fda2": "Groove X, Inc",
    "fda3": "Inseego Corp.",
    "fda4": "Inseego Corp.",
    "fda5": "Neurostim OAB, Inc.",
    "fda6": "WWZN Information Technology Company Limited",
    "fda7": "WWZN Information Technology Company Limited",
    "fda8": "PSA Peugeot Citroën",
    "fda9": "Rhombus Systems, Inc.",
    "fdaa": "Xiaomi Inc.",
    "fdab": "Xiaomi Inc.",
    "fdac": "Tentacle Sync GmbH",
    "fdad": "Houwa System Design, k.k.",
    "fdae": "Houwa System Design, k.k.",
    "fdaf": "Wiliot LTD",
    "fdb0": "Proxy Technologies, Inc.",
    "fdb1": "Proxy Technologies, Inc.",
    "fdb2": "Portable Multimedia Ltd",
    "fdb3": "Audiodo AB",
    "fdb4": "HP Inc",
    "fdb5": "ECSG",
    "fdb6": "GWA Hygiene GmbH",
    "fdb7": "LivaNova USA Inc.",
    "fdb8": "LivaNova USA Inc.",
    "fdb9": "Comcast Cable Corporation",
    "fdba": "Comcast Cable Corporation",
    "fdbb": "Profoto",
    "fdbc": "Emerson",
    "fdbd": "Clover Network, Inc.",
    "fdbe": "California Things Inc.",
    "fdbf": "California Things Inc.",
    "fdc0": "Hunter Douglas",
    "fdc1": "Hunter Douglas",
    "fdc2": "Baidu Online Network Technology (Beijing) Co., Ltd",
    "fdc3": "Baidu Online Network Technology (Beijing) Co., Ltd",
    "fdc4": "Simavita (Aust) Pty Ltd",
    "fdc5": "Automatic Labs",
    "fdc6": "Eli Lilly and Company",
    "fdc7": "Eli Lilly and Company",
    "fdc8": "Hach – Danaher",
    "fdc9": "Busch-Jaeger Elektro GmbH",
    "fdca": "Fortin Electronic Systems",
    "fdcb": "Meggitt SA",
    "fdcc": "Shoof Technologies",
    "fdcd": "Qingping Technology (Beijing) Co., Ltd.",
    "fdce": "SENNHEISER electronic GmbH & Co. KG",
    "fdcf": "Nalu Medical, Inc",
    "fdd0": "Huawei Technologies Co., Ltd",
    "fdd1": "Huawei Technologies Co., Ltd",
    "fdd2": "Bose Corporation",
    "fdd3": "FUBA Automotive Electronics GmbH",
    "fdd4": "LX Solutions Pty Limited",
    "fdd5": "Brompton Bicycle Ltd",
    "fdd6": "Ministry of Supply",
    "fdd7": "Emerson",
    "fdd8": "Jiangsu Teranovo Tech Co., Ltd.",
    "fdd9": "Jiangsu Teranovo Tech Co., Ltd.",
    "fdda": "MHCS",
    "fddb": "Samsung Electronics Co., Ltd.",
    "fddc": "4iiii Innovations Inc.",
    "fddd": "Arch Systems Inc",
    "fdde": "Noodle Technology Inc.",
    "fddf": "Harman International",
    "fde0": "John Deere",
    "fde1": "Fortin Electronic Systems",
    "fde2": "Google Inc.",
    "fde3": "Abbott Diabetes Care",
    "fde4": "JUUL Labs, Inc.",
    "fde5": "SMK Corporation",
    "fde6": "Intelletto Technologies Inc",
    "fde7": "SECOM Co., LTD",
    "fde8": "Robert Bosch GmbH",
    "fde9": "Spacesaver Corporation",
    "fdea": "SeeScan, Inc",
    "fdeb": "Syntronix Corporation",
    "fdec": "Mannkind Corporation",
    "fded": "Pole Star",
    "fdee": "Huawei Technologies Co., Ltd.",
    "fdef": "ART AND PROGRAM, INC.",
    "fdf0": "Google Inc.",
    "fdf1": "LAMPLIGHT Co.,Ltd",
    "fdf2": "AMICCOM Electronics Corporation",
    "fdf3": "Amersports",
    "fdf4": "O. E. M. Controls, Inc.",
    "fdf5": "Milwaukee Electric Tools",
    "fdf6": "AIAIAI ApS",
    "fdf7": "HP Inc.",
    "fdf8": "Onvocal",
    "fdf9": "INIA",
    "fdfa": "Tandem Diabetes Care",
    "fdfb": "Tandem Diabetes Care",
    "fdfc": "Optrel AG",
    "fdfd": "RecursiveSoft Inc.",
    "fdfe": "ADHERIUM(NZ) LIMITED",
    "fdff": "OSRAM GmbH",
    "fe00": "Amazon.com Services, Inc.",
    "fe01": "Duracell U.S. Operations Inc.",
    "fe02": "Robert Bosch GmbH",
    "fe03": "Amazon.com Services, Inc.",
    "fe04": "OpenPath Security Inc",
    "fe05": "CORE Transport Technologies NZ Limited",
    "fe06": "Qualcomm Technologies, Inc.",
    "fe07": "Sonos, Inc.",
    "fe08": "Microsoft",
    "fe09": "Pillsy, Inc.",
    "fe0a": "ruwido austria gmbh",
    "fe0b": "ruwido austria gmbh",
    "fe0c": "Procter & Gamble",
    "fe0d": "Procter & Gamble",
    "fe0e": "Setec Pty Ltd",
    "fe0f": "Signify Netherlands B.V. (formerly Philips Lighting B.V.)",
    "fe10": "LAPIS Technology Co., Ltd.",
    "fe11": "GMC-I Messtechnik GmbH",
    "fe12": "M-Way Solutions GmbH",
    "fe13": "Apple Inc.",
    "fe14": "Flextronics International USA Inc.",
    "fe15": "Amazon.com Services, Inc..",
    "fe16": "Footmarks, Inc.",
    "fe17": "Telit Wireless Solutions GmbH",
    "fe18": "Runtime, Inc.",
    "fe19": "Google, Inc",
    "fe1a": "Tyto Life LLC",
    "fe1b": "Tyto Life LLC",
    "fe1c": "NetMedia, Inc.",
    "fe1d": "Illuminati Instrument Corporation",
    "fe1e": "Smart Innovations Co., Ltd",
    "fe1f": "Garmin International, Inc.",
    "fe20": "Emerson",
    "fe21": "Bose Corporation",
    "fe22": "Zoll Medical Corporation",
    "fe23": "Zoll Medical Corporation",
    "fe24": "August Home Inc",
    "fe25": "Apple, Inc.",
    "fe26": "Google",
    "fe27": "Google",
    "fe28": "Ayla Networks",
    "fe29": "Gibson Innovations",
    "fe2a": "DaisyWorks, Inc.",
    "fe2b": "ITT Industries",
    "fe2c": "Google",
    "fe2d": "SMART INNOVATION Co.,Ltd",
    "fe2e": "ERi,Inc.",
    "fe2f": "CRESCO Wireless, Inc",
    "fe30": "Volkswagen AG",
    "fe31": "Volkswagen AG",
    "fe32": "Pro-Mark, Inc.",
    "fe33": "CHIPOLO d.o.o.",
    "fe34": "SmallLoop LLC",
    "fe35": "HUAWEI Technologies Co., Ltd",
    "fe36": "HUAWEI Technologies Co., Ltd",
    "fe37": "Spaceek LTD",
    "fe38": "Spaceek LTD",
    "fe39": "TTS Tooltechnic Systems AG & Co. KG",
    "fe3a": "TTS Tooltechnic Systems AG & Co. KG",
    "fe3b": "Dolby Laboratories",
    "fe3c": "alibaba",
    "fe3d": "BD Medical",
    "fe3e": "BD Medical",
    "fe3f": "Friday Labs Limited",
    "fe40": "Inugo Systems Limited",
    "fe41": "Inugo Systems Limited",
    "fe42": "Nets A/S",
    "fe43": "Andreas Stihl AG & Co. KG",
    "fe44": "SK Telecom",
    "fe45": "Snapchat Inc",
    "fe46": "B&O Play A/S",
    "fe47": "General Motors",
    "fe48": "General Motors",
    "fe49": "SenionLab AB",
    "fe4a": "OMRON HEALTHCARE Co., Ltd.",
    "fe4b": "Signify Netherlands B.V. (formerly Philips Lighting B.V.)",
    "fe4c": "Volkswagen AG",
    "fe4d": "Casambi Technologies Oy",
    "fe4e": "NTT docomo",
    "fe4f": "Molekule, Inc.",
    "fe50": "Google Inc.",
    "fe51": "SRAM",
    "fe52": "SetPoint Medical",
    "fe53": "3M",
    "fe54": "Motiv, Inc.",
    "fe55": "Google Inc.",
    "fe56": "Google Inc.",
    "fe57": "Dotted Labs",
    "fe58": "Nordic Semiconductor ASA",
    "fe59": "Nordic Semiconductor ASA",
    "fe5a": "Cronologics Corporation",
    "fe5b": "GT-tronics HK Ltd",
    "fe5c": "million hunters GmbH",
    "fe5d": "Grundfos A/S",
    "fe5e": "Plastc Corporation",
    "fe5f": "Eyefi, Inc.",
    "fe60": "Lierda Science & Technology Group Co., Ltd.",
    "fe61": "Logitech International SA",
    "fe62": "Indagem Tech LLC",
    "fe63": "Connected Yard, Inc.",
    "fe64": "Siemens AG",
    "fe65": "CHIPOLO d.o.o.",
    "fe66": "Intel Corporation",
    "fe67": "Lab Sensor Solutions",
    "fe68": "Qualcomm Life Inc",
    "fe69": "Qualcomm Life Inc",
    "fe6a": "Kontakt Micro-Location Sp. z o.o.",
    "fe6b": "TASER International, Inc.",
    "fe6c": "TASER International, Inc.",
    "fe6d": "The University of Tokyo",
    "fe6e": "The University of Tokyo",
    "fe6f": "LINE Corporation",
    "fe70": "Beijing Jingdong Century Trading Co., Ltd.",
    "fe71": "Plume Design Inc",
    "fe72": "Abbott (formerly St. Jude Medical, Inc.)",
    "fe73": "Abbott (formerly St. Jude Medical, Inc.)",
    "fe74": "unwire",
    "fe75": "TangoMe",
    "fe76": "TangoMe",
    "fe77": "Hewlett-Packard Company",
    "fe78": "Hewlett-Packard Company",
    "fe79": "Zebra Technologies",
    "fe7a": "Bragi GmbH",
    "fe7b": "Orion Labs, Inc.",
    "fe7c": "Telit Wireless Solutions (Formerly Stollmann E+V GmbH)",
    "fe7d": "Aterica Health Inc.",
    "fe7e": "Awear Solutions Ltd",
    "fe7f": "Doppler Lab",
    "fe80": "Doppler Lab",
    "fe81": "Medtronic Inc.",
    "fe82": "Medtronic Inc.",
    "fe83": "Blue Bite",
    "fe84": "RF Digital Corp",
    "fe85": "RF Digital Corp",
    "fe86": "HUAWEI Technologies Co., Ltd. ( 华为技术有限公司 )",
    "fe87": "( 青岛亿联客信息技术有限公司 )",
    "fe88": "SALTO SYSTEMS S.L.",
    "fe89": "B&O Play A/S",
    "fe8a": "Apple, Inc.",
    "fe8b": "Apple, Inc.",
    "fe8c": "TRON Forum",
    "fe8d": "Interaxon Inc.",
    "fe8e": "ARM Ltd",
    "fe8f": "CSR",
    "fe90": "JUMA",
    "fe91": "Shanghai Imilab Technology Co.,Ltd",
    "fe92": "Jarden Safety & Security",
    "fe93": "OttoQ In",
    "fe94": "OttoQ In",
    "fe95": "Xiaomi Inc.",
    "fe96": "Tesla Motors Inc.",
    "fe97": "Tesla Motors Inc.",
    "fe98": "Currant Inc",
    "fe99": "Currant Inc",
    "fe9a": "Estimote",
    "fe9b": "Samsara Networks, Inc",
    "fe9c": "GSI Laboratories, Inc.",
    "fe9d": "Mobiquity Networks Inc",
    "fe9e": "Dialog Semiconductor B.V.",
    
    "fea1": "Intrepid Control Systems, Inc.",
    "fea2": "Intrepid Control Systems, Inc.",
    "fea3": "ITT Industries",
    "fea4": "Paxton Access Ltd",
    "fea5": "GoPro, Inc.",
    "fea6": "GoPro, Inc.",
    "fea7": "UTC Fire and Security",
    "fea8": "Savant Systems LLC",
    "fea9": "Savant Systems LLC",
    
    "feab": "Nokia",
    "feac": "Nokia",
    "fead": "Nokia",
    "feae": "Nokia",
    "feaf": "Nest Labs Inc",
    "feb0": "Nest Labs Inc",
    "feb1": "Electronics Tomorrow Limited",
    "feb2": "Microsoft Corporation",
    "feb3": "Taobao",
    "feb4": "WiSilica Inc.",
    "feb5": "WiSilica Inc.",
    "feb6": "Vencer Co., Ltd",
    "feb7": "Facebook, Inc.",
    "feb8": "Facebook, Inc.",
    "feb9": "LG Electronics",
    "feba": "Tencent Holdings Limited",
    "febb": "adafruit industries",
    "febc": "Dexcom Inc",
    "febd": "Clover Network, Inc",
    "febe": "Bose Corporation",
    "febf": "Nod, Inc.",
    "fec0": "KDDI Corporation",
    "fec1": "KDDI Corporation",
    "fec2": "Blue Spark Technologies, Inc.",
    "fec3": "360fly, Inc.",
    "fec4": "PLUS Location Systems",
    "fec5": "Realtek Semiconductor Corp.",
    "fec6": "Kocomojo, LLC",
    "fec7": "Apple, Inc.",
    "fec8": "Apple, Inc.",
    "fec9": "Apple, Inc.",
    "feca": "Apple, Inc.",
    "fecb": "Apple, Inc.",
    "fecc": "Apple, Inc.",
    "fecd": "Apple, Inc.",
    "fece": "Apple, Inc.",
    "fecf": "Apple, Inc.",
    "fed0": "Apple, Inc.",
    "fed1": "Apple, Inc.",
    "fed2": "Apple, Inc.",
    "fed3": "Apple, Inc.",
    "fed4": "Apple, Inc.",
    "fed5": "Plantronics Inc.",
    "fed6": "Broadcom",
    "fed7": "Broadcom",
    "fed8": "Google",
    "fed9": "Pebble Technology Corporation",
    "feda": "ISSC Technologies Corp.",
    "fedb": "Perka, Inc.",
    "fedc": "Jawbone",
    "fedd": "Jawbone",
    "fede": "Coin, Inc.",
    "fedf": "Design SHIFT",
    "fee0": "Anhui Huami Information Technology Co., Ltd.",
    "fee1": "Anhui Huami Information Technology Co., Ltd.",
    "fee2": "Anki, Inc.",
    "fee3": "Anki, Inc.",
    "fee4": "Nordic Semiconductor ASA",
    "fee5": "Nordic Semiconductor ASA",
    "fee6": "Silvair, Inc.",
    "fee7": "Tencent Holdings Limited.",
    "fee8": "Quintic Corp.",
    "fee9": "Quintic Corp.",
    "feea": "Swirl Networks, Inc.",
    "feeb": "Swirl Networks, Inc.",
    "feec": "Tile, Inc.",
    "feed": "Tile, Inc.",
    "feee": "Polar Electro Oy",
    "feef": "Polar Electro Oy",
    "fef0": "Intel",
    "fef1": "CSR",
    "fef2": "CSR",
    "fef3": "Google",
    "fef4": "Google",
    "fef5": "Dialog Semiconductor GmbH",
    "fef6": "Wicentric, Inc.",
    "fef7": "Aplix Corporation",
    "fef8": "Aplix Corporation",
    "fef9": "PayPal, Inc.",
    "fefa": "PayPal, Inc.",
    "fefb": "Telit Wireless Solutions (Formerly Stollmann E+V GmbH)",
    "fefc": "Gimbal, Inc.",
    "fefd": "Gimbal, Inc.",
    "fefe": "GN ReSound A/S",
    "feff": "GN Netcom"
  },
  "GATTCharacteristicandObjectType": {
    "2a00": "Device Name",
    "2a01": "Appearance",
    "2a02": "Peripheral Privacy Flag",
    "2a03": "Reconnection Address",
    "2a04": "Peripheral Preferred Connection Parameters",
    "2a05": "Service Changed",
    "2a06": "Alert Level",
    "2a07": "Tx Power Level",
    "2a08": "Date Time",
    "2a09": "Day of Week",
    "2a0a": "Day Date Time",
    "2a0c": "Exact Time 256",
    "2a0d": "DST Offset",
    "2a0e": "Time Zone",
    "2a0f": "Local Time Information",
    "2a11": "Time with DST",
    "2a12": "Time Accuracy",
    "2a13": "Time Source",
    "2a14": "Reference Time Information",
    "2a16": "Time Update Control Point",
    "2a17": "Time Update State",
    "2a18": "Glucose Measurement",
    "2a19": "Battery Level",
    "2a1c": "Temperature Measurement",
    "2a1d": "Temperature Type",
    "2a1e": "Intermediate Temperature",
    "2a21": "Measurement Interval",
    "2a22": "Boot Keyboard Input Report",
    "2a23": "System ID",
    "2a24": "Model Number String",
    "2a25": "Serial Number String",
    "2a26": "Firmware Revision String",
    "2a27": "Hardware Revision String",
    "2a28": "Software Revision String",
    "2a29": "Manufacturer Name String",
    "2a2a": "IEEE 11073-20601 Regulatory Certification Data List",
    "2a2b": "Current Time",
    "2a31": "Scan Refresh",
    "2a32": "Boot Keyboard Output Report",
    "2a33": "Boot Mouse Input Report",
    "2a34": "Glucose Measurement Context",
    "2a35": "Blood Pressure Measurement",
    "2a36": "Intermediate Cuff Pressure",
    "2a37": "Heart Rate Measurement",
    "2a38": "Body Sensor Location",
    "2a39": "Heart Rate Control Point",
    "2a3f": "Alert Status",
    "2a40": "Ringer Control Point",
    "2a41": "Ringer Setting",
    "2a42": "Alert Category ID Bit Mask",
    "2a43": "Alert Category ID",
    "2a44": "Alert Notification Control Point",
    "2a45": "Unread Alert Status",
    "2a46": "New Alert",
    "2a47": "Supported New Alert Category",
    "2a48": "Supported Unread Alert Category",
    "2a49": "Blood Pressure Feature",
    "2a4a": "HID Information",
    "2a4b": "Report Map",
    "2a4c": "HID Control Point",
    "2a4d": "Report",
    "2a4e": "Protocol Mode",
    "2a4f": "Scan Interval Window",
    "2a50": "PnP ID",
    "2a51": "Glucose Feature",
    "2a52": "Record Access Control Point",
    "2a53": "RSC Measurement",
    "2a54": "RSC Feature",
    "2a55": "SC Control Point",
    "2a5a": "Aggregate",
    "2a5b": "CSC Measurement",
    "2a5c": "CSC Feature",
    "2a5d": "Sensor Location",
    "2a5e": "PLX Spot-Check Measurement",
    "2a5f": "PLX Continuous Measurement",
    "2a60": "PLX Features",
    "2a63": "Cycling Power Measurement",
    "2a64": "Cycling Power Vector",
    "2a65": "Cycling Power Feature",
    "2a66": "Cycling Power Control Point",
    "2a67": "Location and Speed",
    "2a68": "Navigation",
    "2a69": "Position Quality",
    "2a6a": "LN Feature",
    "2a6b": "LN Control Point",
    "2a6c": "Elevation",
    "2a6d": "Pressure",
    "2a6e": "Temperature",
    "2a6f": "Humidity",
    "2a70": "True Wind Speed",
    "2a71": "True Wind Direction",
    "2a72": "Apparent Wind Speed",
    "2a73": "Apparent Wind Direction",
    "2a74": "Gust Factor",
    "2a75": "Pollen Concentration",
    "2a76": "UV Index",
    "2a77": "Irradiance",
    "2a78": "Rainfall",
    "2a79": "Wind Chill",
    "2a7a": "Heat Index",
    "2a7b": "Dew Point",
    "2a7d": "Descriptor Value Changed",
    "2a7e": "Aerobic Heart Rate Lower Limit",
    "2a7f": "Aerobic Threshold",
    "2a80": "Age",
    "2a81": "Anaerobic Heart Rate Lower Limit",
    "2a82": "Anaerobic Heart Rate Upper Limit",
    "2a83": "Anaerobic Threshold",
    "2a84": "Aerobic Heart Rate Upper Limit",
    "2a85": "Date of Birth",
    "2a86": "Date of Threshold Assessment",
    "2a87": "Email Address",
    "2a88": "Fat Burn Heart Rate Lower Limit",
    "2a89": "Fat Burn Heart Rate Upper Limit",
    "2a8a": "First Name",
    "2a8b": "Five Zone Heart Rate Limits",
    "2a8c": "Gender",
    "2a8d": "Heart Rate Max",
    "2a8e": "Height",
    "2a8f": "Hip Circumference",
    "2a90": "Last Name",
    "2a91": "Maximum Recommended Heart Rate",
    "2a92": "Resting Heart Rate",
    "2a93": "Sport Type for Aerobic and Anaerobic Thresholds",
    "2a94": "Three Zone Heart Rate Limits",
    "2a95": "Two Zone Heart Rate Limits",
    "2a96": "VO2 Max",
    "2a97": "Waist Circumference",
    "2a98": "Weight",
    "2a99": "Database Change Increment",
    "2a9a": "User Index",
    "2a9b": "Body Composition Feature",
    "2a9c": "Body Composition Measurement",
    "2a9d": "Weight Measurement",
    "2a9e": "Weight Scale Feature",
    "2a9f": "User Control Point",
    "2aa0": "Magnetic Flux Density - 2D",
    "2aa1": "Magnetic Flux Density - 3D",
    "2aa2": "Language",
    "2aa3": "Barometric Pressure Trend",
    "2aa4": "Bond Management Control Point",
    "2aa5": "Bond Management Feature",
    "2aa6": "Central Address Resolution",
    "2aa7": "CGM Measurement",
    "2aa8": "CGM Feature",
    "2aa9": "CGM Status",
    "2aaa": "CGM Session Start Time",
    "2aab": "CGM Session Run Time",
    "2aac": "CGM Specific Ops Control Point",
    "2aad": "Indoor Positioning Configuration",
    "2aae": "Latitude",
    "2aaf": "Longitude",
    "2ab0": "Local North Coordinate",
    "2ab1": "Local East Coordinate",
    "2ab2": "Floor Number",
    "2ab3": "Altitude",
    "2ab4": "Uncertainty",
    "2ab5": "Location Name",
    "2ab6": "URI",
    "2ab7": "HTTP Headers",
    "2ab8": "HTTP Status Code",
    "2ab9": "HTTP Entity Body",
    "2aba": "HTTP Control Point",
    "2abb": "HTTPS Security",
    "2abc": "TDS Control Point",
    "2abd": "OTS Feature",
    "2abe": "object name",
    "2abf": "object type",
    "2ac0": "object size",
    "2ac1": "object first created",
    "2ac2": "object last modified",
    "2ac3": "object ID",
    "2ac4": "object properties",
    "2ac5": "object actioncontrol point",
    "2ac6": "object list control point",
    "2ac7": "object list filter",
    "2ac8": "object changed",
    "2ac9": "Resolvable Private Address Only",
    "2aca": "Unspecified",
    "2acb": "Directory Listing",
    "2acc": "Fitness Machine Feature",
    "2acd": "Treadmill Data",
    "2ace": "Cross Trainer Data",
    "2acf": "Step Climber Data",
    "2ad0": "Stair Climber Data",
    "2ad1": "Rower Data",
    "2ad2": "Indoor Bike Data",
    "2ad3": "Training Status",
    "2ad4": "Supported Speed Range",
    "2ad5": "Supported Inclination Range",
    "2ad6": "Supported Resistance Level Range",
    "2ad7": "Supported Heart Rate Range",
    "2ad8": "Supported Power Range",
    "2ad9": "Fitness Machine Control Point",
    "2ada": "Fitness Machine Status",
    "2adb": "Mesh Provisioning Data In",
    "2adc": "Mesh Provisioning Data Out",
    "2add": "Mesh Proxy Data In",
    "2ade": "Mesh Proxy Data Out",
    "2ae0": "Average Current",
    "2ae1": "Average Voltage",
    "2ae2": "Boolean",
    "2ae3": "Chromatic Distance From Planckian",
    "2ae4": "Chromaticity Coordinates",
    "2ae5": "Chromaticity in CCT And Duv Values",
    "2ae6": "Chromaticity Tolerance",
    "2ae7": "CIE 13.3-1995 Color Rendering Index",
    "2ae8": "Coefficient",
    "2ae9": "Correlated Color Temperature",
    "2aea": "Count 16",
    "2aeb": "Count 24",
    "2aec": "Country Code",
    "2aed": "Date UTC",
    "2aee": "Electric Current",
    "2aef": "Electric Current Range",
    "2af0": "Electric Current Specification",
    "2af1": "Electric Current Statistics",
    "2af2": "Energy",
    "2af3": "Energy In A Period Of Day",
    "2af4": "Event Statistics",
    "2af5": "Fixed String 16",
    "2af6": "Fixed String 24",
    "2af7": "Fixed String 36",
    "2af8": "Fixed String 8",
    "2af9": "Generic Level",
    "2afa": "Global Trade Item Number",
    "2afb": "Illuminance",
    "2afc": "Luminous Efficacy",
    "2afd": "Luminous Energy",
    "2afe": "Luminous Exposure",
    "2aff": "Luminous Flux",
    "2b00": "Luminous Flux Range",
    "2b01": "Luminous Intensity",
    "2b02": "Mass Flow",
    "2b03": "Perceived Lightness",
    "2b04": "Percentage 8",
    "2b05": "Power",
    "2b06": "Power Specification",
    "2b07": "Relative Runtime In A Current Range",
    "2b08": "Relative Runtime In A Generic Level Range",
    "2b09": "Relative Value In A Voltage Range",
    "2b0a": "Relative Value In An Illuminance Range",
    "2b0b": "Relative Value In A Period Of Day",
    "2b0c": "Relative Value In A Temperature Range",
    "2b0d": "Temperature 8",
    "2b0e": "Temperature 8 In A Period Of Day",
    "2b0f": "Temperature 8 Statistics",
    "2b10": "Temperature Range",
    "2b11": "Temperature Statistics",
    "2b12": "Time Decihour 8",
    "2b13": "Time Exponential 8",
    "2b14": "Time Hour 24",
    "2b15": "Time Millisecond 24",
    "2b16": "Time Second 16",
    "2b17": "Time Second 8",
    "2b18": "Voltage",
    "2b19": "Voltage Specification",
    "2b1a": "Voltage Statistics",
    "2b1b": "Volume Flow",
    "2b1c": "Chromaticity Coordinate",
    "2b1d": "RC Feature",
    "2b1e": "RC Settings",
    "2b1f": "Reconnection Configuration Control Point",
    "2b20": "IDD Status Changed",
    "2b21": "IDD Status",
    "2b22": "IDD Annunciation Status",
    "2b23": "IDD Features",
    "2b24": "IDD Status Reader Control Point",
    "2b25": "IDD Command Control Point",
    "2b26": "IDD Command Data",
    "2b27": "IDD Record Access Control Point",
    "2b28": "IDD History Data",
    "2b29": "Client Supported Features",
    "2b2a": "Database Hash",
    "2b2b": "BSS Control Point",
    "2b2c": "BSS Response",
    "2b2d": "Emergency ID",
    "2b2e": "Emergency Text",
    "2b34": "Enhanced Blood Pressure Measurement",
    "2b35": "Enhanced Intermediate Cuff Pressure",
    "2b36": "Blood Pressure Record",
    "2b38": "BR-EDR Handover Data",
    "2b39": "Bluetooth SIG Data",
    "2b3a": "Server Supported Features",
    "2b3b": "Physical Activity Monitor Features",
    "2b3c": "General Activity Instantaneous Data",
    "2b3d": "General Activity Summary Data",
    "2b3e": "CardioRespiratory Activity Instantaneous Data",
    "2b3f": "CardioRespiratory Activity Summary Data",
    "2b40": "Step Counter Activity Summary Data",
    "2b41": "Sleep Activity Instantaneous Data",
    "2b42": "Sleep Activity Summary Data",
    "2b43": "Physical Activity Monitor Control Point",
    "2b44": "Current Session",
    "2b45": "Session",
    "2b46": "Preferred Units",
    "2b47": "High Resolution Height",
    "2b48": "Middle Name",
    "2b49": "Stride Length",
    "2b4a": "Handedness",
    "2b4b": "Device Wearing Position",
    "2b4c": "Four Zone Heart Rate Limits",
    "2b4d": "High Intensity Exercise Threshold",
    "2b4e": "Activity Goal",
    "2b4f": "Sedentary Interval Notification",
    "2b50": "Caloric Intake",
    "2b51": "TMAP Role characteristic",
    "2b77": "Audio Input State",
    "2b78": "Gain Settings Attribute",
    "2b79": "Audio Input Type",
    "2b7a": "Audio Input Status",
    "2b7b": "Audio Input Control Point",
    "2b7c": "Audio Input Description",
    "2b7d": "Volume State",
    "2b7e": "Volume Control Point",
    "2b7f": "Volume Flags",
    "2b80": "Offset State",
    "2b81": "Audio Location",
    "2b82": "Volume Offset Control Point",
    "2b83": "Audio Output Description",
    "2b84": "Set Identity Resolving Key Characteristic",
    "2b85": "Size Characteristic",
    "2b86": "Lock Characteristic",
    "2b87": "Rank Characteristic",
    "2b8e": "Device Time Feature",
    "2b8f": "Device Time Parameters",
    "2b90": "Device Time",
    "2b91": "Device Time Control Point",
    "2b92": "Time Change Log Data",
    "2b93": "Media Player Name",
    "2b94": "Media Player Icon Object ID",
    "2b95": "Media Player Icon URL",
    "2b96": "Track Changed",
    "2b97": "Track Title",
    "2b98": "Track Duration",
    "2b99": "Track Position",
    "2b9a": "Playback Speed",
    "2b9b": "Seeking Speed",
    "2b9c": "Current Track Segments Object ID",
    "2b9d": "Current Track Object ID",
    "2b9e": "Next Track Object ID",
    "2b9f": "Parent Group Object ID",
    "2ba0": "Current Group Object ID",
    "2ba1": "Playing Order",
    "2ba2": "Playing Orders Supported",
    "2ba3": "Media State",
    "2ba4": "Media Control Point",
    "2ba5": "Media Control Point Opcodes Supported",
    "2ba6": "Search Results Object ID",
    "2ba7": "Search Control Point",
    "2ba9": "Media Player Icon Object Type",
    "2baa": "Track Segments Object Type",
    "2bab": "Track Object Type",
    "2bac": "Group Object Type",
    "2bad": "Constant Tone Extension Enable",
    "2bae": "Advertising Constant Tone Extension Minimum Length",
    "2baf": "Advertising Constant Tone Extension Minimum Transmit Count",
    "2bb0": "Advertising Constant Tone Extension Transmit Duration",
    "2bb1": "Advertising Constant Tone Extension Interval",
    "2bb2": "Advertising Constant Tone Extension PHY",
    "2bb3": "Bearer Provider Name",
    "2bb4": "Bearer UCI",
    "2bb5": "Bearer Technology",
    "2bb6": "Bearer URI Schemes Supported List",
    "2bb7": "Bearer Signal Strength",
    "2bb8": "Bearer Signal Strength Reporting Interval",
    "2bb9": "Bearer List Current Calls",
    "2bba": "Content Control ID",
    "2bbb": "Status Flags",
    "2bbc": "Incoming Call Target Bearer URI",
    "2bbd": "Call State",
    "2bbe": "Call Control Point",
    "2bbf": "Call Control Point Optional Opcodes",
    "2bc0": "Termination Reason",
    "2bc1": "Incoming Call",
    "2bc2": "Call Friendly Name",
    "2bc3": "Mute",
    "2bc4": "Sink ASE",
    "2bc5": "Source ASE",
    "2bc6": "ASE Control Point",
    "2bc7": "Broadcast Audio Scan Control Point",
    "2bc8": "Broadcast Receive State",
    "2bc9": "Sink PAC",
    "2bca": "Sink Audio Locations",
    "2bcb": "Source PAC",
    "2bcc": "Source Audio Locations",
    "2bcd": "Available Audio Contexts",
    "2bce": "Supported Audio Contexts",
    "2bcf": "Ammonia Concentration",
    "2bd0": "Carbon Monoxide Concentration",
    "2bd1": "Methane Concentration",
    "2bd2": "Nitrogen Dioxide Concentration",
    "2bd3": "Non-Methane Volatile Organic Compounds Concentration",
    "2bd4": "Ozone Concentration",
    "2bd5": "Particulate Matter - PM1 Concentration",
    "2bd6": "Particulate Matter - PM2.5 Concentration",
    "2bd7": "Particulate Matter - PM10 Concentration",
    "2bd8": "Sulfur Dioxide Concentration",
    "2bd9": "Sulfur Hexafluoride Concentration"
  },
  "GATTDeclarations": {
    "2800": "Primary Service",
    "2801": "Secondary Service",
    "2802": "Include",
    "2803": "Characteristic"
  },
  "GATTDescriptor": {
    "2900": "Characteristic Extended Properties",
    "2901": "Characteristic User Description",
    "2902": "Client Characteristic Configuration",
    "2903": "Server Characteristic Configuration",
    "2904": "Characteristic Presentation Format",
    "2905": "Characteristic Aggregate Format",
    "2906": "Valid Range",
    "2907": "External Report Reference",
    "2908": "Report Reference",
    "2909": "Number of Digitals",
    "290a": "Value Trigger Setting",
    "290b": "Environmental Sensing Configuration",
    "290c": "Environmental Sensing Measurement",
    "290d": "Environmental Sensing Trigger Setting",
    "290e": "Time Trigger Setting",
    "290f": "Complete BR-EDR Transport Block Data"
  },
  "GATTService": {
    "1800": "Generic Access",
    "1801": "Generic Attribute",
    "1802": "Immediate Alert",
    "1803": "Link Loss",
    "1804": "Tx Power",
    "1805": "Current Time",
    "1806": "Reference Time Update",
    "1807": "Next DST Change",
    "1808": "Glucose",
    "1809": "Health Thermometer",
    "1810": "Blood Pressure",
    "1811": "Alert Notification",
    "1812": "Human Interface Device",
    "1813": "Scan Parameters",
    "1814": "Running Speed and Cadence",
    "1815": "Automation IO",
    "1816": "Cycling Speed and Cadence",
    "1818": "Cycling Power",
    "1819": "Location and Navigation",
    "1820": "Internet Protocol Support",
    "1821": "Indoor Positioning",
    "1822": "Pulse Oximeter",
    "1823": "HTTP Proxy",
    "1824": "Transport Discovery",
    "1825": "Object Transfer",
    "1826": "Fitness Machine",
    "1827": "Mesh Provisioning",
    "1828": "Mesh Proxy",
    "1829": "Reconnection Configuration",
    "1843": "Audio Input Control",
    "1844": "Volume Control",
    "1845": "Volume Offset Control",
    "1846": "Coordinated Set Identification Service",
    "1847": "Device Time",
    "1848": "Media Control Service",
    "1849": "Generic Media Control Service",
    "1850": "Published Audio Capabilities Service",
    "1851": "Basic Audio Announcement Service",
    "1852": "Broadcast Audio Announcement Service",
    "1853": "Common Audio Service",
    "1854": "Hearing Access Service",
    "1855": "TMAS Service",
    "180a": "Device Information",
    "180d": "Heart Rate",
    "180e": "Phone Alert Status",
    "180f": "Battery",
    "181a": "Environmental Sensing",
    "181b": "Body Composition",
    "181c": "User Data",
    "181d": "Weight Scale",
    "181e": "Bond Management",
    "181f": "Continuous Glucose Monitoring",
    "183a": "Insulin Delivery",
    "183b": "Binary Sensor",
    "183c": "Emergency Configuration",
    "183e": "Physical Activity Monitor",
    "184a": "Constant Tone Extension",
    "184b": "Telephone Bearer Service",
    "184c": "Generic Telephone Bearer Service",
    "184d": "Microphone Control",
    "184e": "Audio Stream Control Service",
    "184f": "Broadcast Audio Scan Service"
  },
  "GATTUnit": {
    "2700": "unitless",
    "2701": "length (metre)",
    "2702": "mass (kilogram)",
    "2703": "time (second)",
    "2704": "electric current (ampere)",
    "2705": "thermodynamic temperature (kelvin)",
    "2706": "amount of substance (mole)",
    "2707": "luminous intensity (candela)",
    "2710": "area (square metres)",
    "2711": "volume (cubic metres)",
    "2712": "velocity (metres per second)",
    "2713": "acceleration (metres per second squared)",
    "2714": "wavenumber (reciprocal metre)",
    "2715": "density (kilogram per cubic metre)",
    "2716": "surface density (kilogram per square metre)",
    "2717": "specific volume (cubic metre per kilogram)",
    "2718": "current density (ampere per square metre)",
    "2719": "magnetic field strength (ampere per metre)",
    "2720": "plane angle (radian)",
    "2721": "solid angle (steradian)",
    "2722": "frequency (hertz)",
    "2723": "force (newton)",
    "2724": "pressure (pascal)",
    "2725": "energy (joule)",
    "2726": "power (watt)",
    "2727": "electric charge (coulomb)",
    "2728": "electric potential difference (volt)",
    "2729": "capacitance (farad)",
    "2730": "luminous flux (lumen)",
    "2731": "illuminance (lux)",
    "2732": "activity referred to a radionuclide (becquerel)",
    "2733": "absorbed dose (gray)",
    "2734": "dose equivalent (sievert)",
    "2735": "catalytic activity (katal)",
    "2740": "dynamic viscosity (pascal second)",
    "2741": "moment of force (newton metre)",
    "2742": "surface tension (newton per metre)",
    "2743": "angular velocity (radian per second)",
    "2744": "angular acceleration (radian per second squared)",
    "2745": "heat flux density (watt per square metre)",
    "2746": "heat capacity (joule per kelvin)",
    "2747": "specific heat capacity (joule per kilogram kelvin)",
    "2748": "specific energy (joule per kilogram)",
    "2749": "thermal conductivity (watt per metre kelvin)",
    "2750": "permeability (henry per metre)",
    "2751": "molar energy (joule per mole)",
    "2752": "molar entropy (joule per mole kelvin)",
    "2753": "exposure (coulomb per kilogram)",
    "2754": "absorbed dose rate (gray per second)",
    "2755": "radiant intensity (watt per steradian)",
    "2756": "radiance (watt per square metre steradian)",
    "2757": "catalytic activity concentration (katal per cubic metre)",
    "2760": "time (minute)",
    "2761": "time (hour)",
    "2762": "time (day)",
    "2763": "plane angle (degree)",
    "2764": "plane angle (minute)",
    "2765": "plane angle (second)",
    "2766": "area (hectare)",
    "2767": "volume (litre)",
    "2768": "mass (tonne)",
    "2780": "pressure (bar)",
    "2781": "pressure (millimetre of mercury)",
    "2782": "length (ångström)",
    "2783": "length (nautical mile)",
    "2784": "area (barn)",
    "2785": "velocity (knot)",
    "2786": "logarithmic radio quantity (neper)",
    "2787": "logarithmic radio quantity (bel)",
    "271a": "amount concentration (mole per cubic metre)",
    "271b": "mass concentration (kilogram per cubic metre)",
    "271c": "luminance (candela per square metre)",
    "271d": "refractive index",
    "271e": "relative permeability",
    "272a": "electric resistance (ohm)",
    "272b": "electric conductance (siemens)",
    "272c": "magnetic flux (weber)",
    "272d": "magnetic flux density (tesla)",
    "272e": "inductance (henry)",
    "272f": "Celsius temperature (degree Celsius)",
    "274a": "energy density (joule per cubic metre)",
    "274b": "electric field strength (volt per metre)",
    "274c": "electric charge density (coulomb per cubic metre)",
    "274d": "surface charge density (coulomb per square metre)",
    "274e": "electric flux density (coulomb per square metre)",
    "274f": "permittivity (farad per metre)",
    "27a0": "length (yard)",
    "27a1": "length (parsec)",
    "27a2": "length (inch)",
    "27a3": "length (foot)",
    "27a4": "length (mile)",
    "27a5": "pressure (pound-force per square inch)",
    "27a6": "velocity (kilometre per hour)",
    "27a7": "velocity (mile per hour)",
    "27a8": "angular velocity (revolution per minute)",
    "27a9": "energy (gram calorie)",
    "27aa": "energy (kilogram calorie)",
    "27ab": "energy (kilowatt hour)",
    "27ac": "thermodynamic temperature (degree Fahrenheit)",
    "27ad": "percentage",
    "27ae": "per mille",
    "27af": "period (beats per minute)",
    "27b0": "electric charge (ampere hours)",
    "27b1": "mass density (milligram per decilitre)",
    "27b2": "mass density (millimole per litre)",
    "27b3": "time (year)",
    "27b4": "time (month)",
    "27b5": "concentration (count per cubic metre)",
    "27b6": "irradiance (watt per square metre)",
    "27b7": "milliliter (per kilogram per minute)",
    "27b8": "mass (pound)",
    "27b9": "metabolic equivalent",
    "27ba": "step (per minute)",
    "27bc": "stroke (per minute)",
    "27bd": "pace (kilometre per minute)",
    "27be": "luminous efficacy (lumen per watt)",
    "27bf": "luminous energy (lumen hour)",
    "27c0": "luminous exposure (lux hour)",
    "27c1": "mass flow (gram per second)",
    "27c2": "volume flow (litre per second)",
    "27c3": "sound pressure (decible)",
    "27c4": "parts per million",
    "27c5": "parts per billion"
  },
  "ProtocolIdentifier": {
    "0001": "SDP",
    "0002": "UDP",
    "0003": "RFCOMM",
    "0004": "TCP",
    "0005": "TCS-BIN",
    "0006": "TCS-AT",
    "0007": "ATT",
    "0008": "OBEX",
    "0009": "IP",
    "000a": "FTP",
    "000c": "HTTP",
    "000e": "WSP",
    "000f": "BNEP",
    "0010": "UPNP",
    "0011": "HIDP",
    "0012": "HardcopyControlChannel",
    "0014": "HardcopyDataChannel",
    "0016": "HardcopyNotification",
    "0017": "AVCTP",
    "0019": "AVDTP",
    "001b": "CMTP",
    "001e": "MCAPControlChannel",
    "001f": "MCAPDataChannel",
    "0100": "L2CAP"
  },
  "SDOGATTService": {
    "fff3": "FiRa Consortium",
    "fff4": "FiRa Consortium",
    "fff5": "Car Connectivity Consortium, LLC",
    "fff6": "ZigBee Alliance",
    "fff7": "ZigBee Alliance",
    "fff8": "Mopria Alliance",
    "fff9": "Fast IDentity Online Alliance (FIDO)",
    "fffa": "ASTM International",
    "fffb": "Thread Group, Inc.",
    "fffc": "AirFuel Alliance",
    "fffd": "Fast IDentity Online Alliance (FIDO)",
    "fffe": "AirFuel Alliance (formerly Alliance for Wireless Power)"
  },
  "ServiceClassesandProfiles": {
    "fd6f": "Contact Tracing",
    "1000": "ServiceDiscoveryServerServiceClassID",
    "1001": "BrowseGroupDescriptorServiceClassID",
    "1101": "SerialPort",
    "1102": "LANAccessUsingPPP",
    "1103": "DialupNetworking",
    "1104": "IrMCSync",
    "1105": "OBEXObjectPush",
    "1106": "OBEXFileTransfer",
    "1107": "IrMCSyncCommand",
    "1108": "Headset",
    "1109": "CordlessTelephony",
    "1110": "Intercom",
    "1111": "Fax",
    "1112": "Headset - Audio Gateway",
    "1113": "WAP",
    "1114": "WAP_CLIENT",
    "1115": "PANU",
    "1116": "NAP",
    "1117": "GN",
    "1118": "DirectPrinting",
    "1119": "ReferencePrinting",
    "1120": "DirectPrintingReferenceObjectsService",
    "1121": "ReflectedUI",
    "1122": "BasicPrinting",
    "1123": "PrintingStatus",
    "1124": "HumanInterfaceDeviceService",
    "1125": "HardcopyCableReplacement",
    "1126": "HCR_Print",
    "1127": "HCR_Scan",
    "1128": "Common_ISDN_Access",
    "1130": "Phonebook Access",
    "1131": "Headset - HS",
    "1132": "Message Access Server",
    "1133": "Message Notification Server",
    "1134": "Message Access Profile",
    "1135": "GNSS",
    "1136": "GNSS_Server",
    "1137": "3D Display",
    "1138": "3D Glasses",
    "1139": "3D Synchronization",
    "1200": "PnPInformation",
    "1201": "GenericNetworking",
    "1202": "GenericFileTransfer",
    "1203": "GenericAudio",
    "1204": "GenericTelephony",
    "1205": "UPNP_Service",
    "1206": "UPNP_IP_Service",
    "1300": "ESDP_UPNP_IP_PAN",
    "1301": "ESDP_UPNP_IP_LAP",
    "1302": "ESDP_UPNP_L2CAP",
    "1303": "VideoSource",
    "1304": "VideoSink",
    "1305": "VideoDistribution",
    "1400": "HDP",
    "1401": "HDP Source",
    "1402": "HDP Sink",
    "110a": "AudioSource",
    "110b": "AudioSink",
    "110c": "A/V_RemoteControlTarget",
    "110d": "AdvancedAudioDistribution",
    "110e": "A/V_RemoteControl",
    "110f": "A/V_RemoteControlController",
    "111a": "Basic Imaging Profile",
    "111b": "ImagingResponder",
    "111c": "ImagingAutomaticArchive",
    "111d": "ImagingReferencedObjects",
    "111e": "Handsfree",
    "111f": "HandsfreeAudioGateway",
    "112d": "SIM_Access",
    "112e": "Phonebook Access - PCE",
    "112f": "Phonebook Access - PSE",
    "113a": "MPS Profile UUID",
    "113b": "MPS SC UUID",
    "113c": "CTN Access Service",
    "113d": "CTN Notification Service",
    "113e": "CTN Profile"
  }
}
